import React from 'react';
import { Link } from 'gatsby';

const BlogList = ({ data }) => {
  // class BlogList extends React.Component {
  return (
    <>
      {/* <div className="news--container">
        {data.allWpPost.nodes.map(({ node }) => (
          <Link className="news--card" to={node.slug}>
            <div className="news--text">
              <div className="news--info">
                <span className="news--date">{node.date}</span>
                <span className="news--tag">{node.categories[0].name}</span>
              </div>
              <h2 className="news--title">{node.title}</h2>
            </div>
          </Link>
        ))}
      </div> */}
      <div className="news--container">
        {data.allWpPost.nodes.map((node) => (
          <Link className="news--card" to={node.slug}>
            <div className="news--text">
              <div className="news--info">
                <span className="news--date">{node.date}</span>
                {/* <span className="news--tag">{node.categories[0].name}</span> */}
              </div>
              <h2 className="news--title">{node.title}</h2>
              {/* <div dangerouslySetInnerHTML={{ __html: node.content }} /> */}
            </div>
          </Link>
        ))}
        {/* <div className="news--next">Next update coming soon.</div> */}
      </div>
    </>
  );
};

export default BlogList;
